export const bgnToEur = (bgn: number) => (bgn / 1.95583).toFixed(2);
